(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ecCom"), require("antd"), require("mobx"), require("React"), require("comsMobx"), require("ReactDOM"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["ecCom", "antd", "mobx", "React", "comsMobx", "ReactDOM", "jQuery"], factory);
	else if(typeof exports === 'object')
		exports["weaHrm"] = factory(require("ecCom"), require("antd"), require("mobx"), require("React"), require("comsMobx"), require("ReactDOM"), require("jQuery"));
	else
		root["weaHrm"] = factory(root["ecCom"], root["antd"], root["mobx"], root["React"], root["comsMobx"], root["ReactDOM"], root["jQuery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_545__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition